module.exports = __webpack_public_path__ + "static/img/footer-logo.a3e005b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer-logo.png
// module id = DSQX
// module chunks = 0